import { Box, Group, Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface EventsHeaderProps {
  title?: string;
  actions?: ReactNode;
  alignActions?: 'left' | 'right';
  actionsGrow?: boolean;
  radiusTop?: number | string;
  titleNoWrap?: boolean;
  titleMaxWidth?: number | string;
}

/**
 * EventsHeader — тулбар блока событий (фон, тень, белый текст).
 */
export function EventsHeader({
  title = 'Лента',
  actions,
  alignActions = 'right',
  actionsGrow = false,
  radiusTop = 8,
  titleNoWrap = false,
  titleMaxWidth,
}: EventsHeaderProps) {
  const normalizedRadius = typeof radiusTop === 'number' ? `${radiusTop}px` : radiusTop;
  const normalizedTitleMaxWidth =
    typeof titleMaxWidth === 'number' ? `${titleMaxWidth}px` : titleMaxWidth;
  return (
    <Box
      c='dark'
      px={12}
      py={8}
      style={{
        backgroundColor: '#ffffff',
        borderLeft: 'solid 1px #e9e9e9',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        borderRadius: `${normalizedRadius} ${normalizedRadius} 0 0`,
        position: 'relative',
        zIndex: 2,
      }}
    >
      <Group gap='xs' wrap={titleNoWrap ? 'nowrap' : 'wrap'} align='center'>
        <Text
          fw={600}
          c='dark'
          lh='16px'
          style={{
            fontSize: 'var(--mantine-font-size-xs)',
            maxWidth: normalizedTitleMaxWidth,
            minWidth: titleNoWrap ? 0 : undefined,
            whiteSpace: titleNoWrap ? 'nowrap' : undefined,
            overflow: titleNoWrap ? 'hidden' : undefined,
            textOverflow: titleNoWrap ? 'ellipsis' : undefined,
          }}
        >
          {title}
        </Text>
        {actions && (
          <Group
            gap='xs'
            ml={alignActions === 'right' ? 'auto' : undefined}
            style={actionsGrow ? { flex: 1 } : undefined}
          >
            {actions}
          </Group>
        )}
      </Group>
    </Box>
  );
}
